export default {"src":"/_next/static/media/atom.8b42866d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};